import React, { useContext } from "react";
import Label from "~/componentes/CustomForm/Label";
import { Input, TextArea, Select } from "~/componentes/CustomForm";
import ColoredButton from "~/componentes/Button/Styles/ColoredButton";
import sistemaListStore from "../../../../../../componentes/SistemaList/ThisMainComponent/thisStore";
import { useState } from "react";
import { useEffect } from "react";

import { CardAtividade, Container } from "./styles";
import IconModalOrcamentoAtividade from '~/assets/icones/modal/IconModalOrcamentoAtividade.svg';
import api from "~/services/api";

function AtividadesList({ defaultData }) {
  const [atividades, setAtividades] = useState([]);
  const { state } = useContext(sistemaListStore);

  useEffect(() => {
    if (Array.isArray(defaultData)) {
      if (defaultData?.length > 0) {
        let aAtividade = [];
        let item = 1;

        for (const itemAtividade of defaultData) {
          let itensAtividade = [];
          let percentualEvol = 0;

          for (const itemItens of itemAtividade?.itensAtividade) {
            itensAtividade.push({ ...itemItens });

            percentualEvol += itemItens?.percentualEvolucao || 0;
          }

          aAtividade.push({
            ...itemAtividade,
            percentualEvolucao: percentualEvol / (itemAtividade?.itensAtividade?.length),
            itensAtividade
          });

          item++;
        }
  
        setAtividades(aAtividade);
      }
    }
  }, [defaultData]);
  
  return (
    <Container>
      <Label title="Atividades *" className="titulo-label" row={true}>
      </Label>
      <CardAtividade>
        <div className="card-atv-header">
          <div className="titulos-tab">
            <div className="col w1">
              <p className="titulo">Índice</p>
            </div>
            <div className="col w6">
              <p className="titulo">Título <span></span></p>
            </div>
            <div className="col w3">
              <p className="titulo">Prev Inicio <span>*</span></p>
            </div>
            <div className="col w3">
              <p className="titulo">Prev Entrega <span>*</span></p>
            </div>
            <div className="col w2">
              <p className="titulo">% Evolução <span>*</span></p>
            </div>
          </div>
        </div>
        {atividades?.map((itemData, index) => (
          <div className="card-atv-body">
            <div className="row no-margin row-top">
              <div className="col w1">
                <Input
                  placeholder="1"
                  name="indiceAt"
                  required="true"
                  value={itemData?.indice}
                  disabled={true}
                />
              </div>
              <div className="col w6">
                <Input
                  placeholder="Titulo da Atividade"
                  name="tituloAtividadeAt"
                  required="true"
                  value={itemData?.titulo}
                  disabled={true}
                />
              </div>
              <div className="col w3">
                <Input
                  type="date"
                  name="dataPrevInicioTarefaAt"
                  value={itemData?.dataPrevInicio}
                  disabled={true}
                />
              </div>
              <div className="col w3">
                <Input
                  type="date"
                  name="dataPrevFinalTarefaAt"
                  value={itemData?.dataPrevFinal}
                  disabled={true}
                />
              </div>
              <div className="col w2">
                <Input
                  type="number"
                  name="percentualEvolucaoTarefaAt"
                  value={itemData?.percentualEvolucao}
                  disabled={true}
                />
              </div>
            </div>
            <div className="sub-atividade">
              <div className="card-sub-atv-header">
                <div className="titulos-tab">
                  <div className="col w1">
                    <p className="titulo">Índice</p>
                  </div>
                  <div className="col w6">
                    <p className="titulo">Título Tarefa <span>*</span></p>
                  </div>
                  <div className="col w2">
                    <p className="titulo">Responsavel <span>*</span></p>
                  </div>
                  <div className="col w2">
                    <p className="titulo">Status Tarefa <span>*</span></p>
                  </div>
                  <div className="col w2">
                    <p className="titulo">Prev Inicio <span>*</span></p>
                  </div>
                  <div className="col w2">
                    <p className="titulo">Prev Entrega <span>*</span></p>
                  </div>
                  <div className="col w1">
                    <p className="titulo">% Evol. <span>*</span></p>
                  </div>
                </div>
              </div>
              {itemData?.itensAtividade?.map((itemAtividade, indexAtividade) => (
                <div className="row no-margin row-top">
                  <div className="col w1">
                    <Input
                      placeholder="1"
                      name="indiceAt"
                      required="true"
                      value={itemAtividade?.indice}
                      disabled={true}
                    />
                  </div>
                  <div className="col w6">
                    <Input
                      placeholder="Titulo da Tarefa"
                      name="tituloTarefaAt"
                      required="true"
                      value={itemAtividade?.titulo}
                      disabled={true}
                    />
                  </div>
                  <div className="col w2">
                    <Select
                      isString
                      list={{ list: [{ id: "E", titulo: "Erpworks" }, { id: "C", titulo: "Cliente" }], value: "id", label: "titulo" }}
                      name={"responsabilidade" + indexAtividade}
                      firstOption
                      required="true"
                      disabled={true}
                      value={itemAtividade?.responsabilidade}
                    />
                  </div>
                  <div className="col w2">
                    <Select
                      isString
                      list={{ list: [{ id: "N", titulo: "Não Iniciado" }, { id: "E", titulo: "Em Execução" }, { id: "C", titulo: "Concluído" }], value: "id", label: "titulo" }}
                      name={"statusTarefa" + indexAtividade}
                      required="true"
                      disabled={true}
                      value={itemAtividade?.statusTarefa}
                    />
                  </div>
                  <div className="col w2">
                    <Input
                      type="date"
                      name="dataPrevInicioTarefaAt"
                      value={itemAtividade?.dataPrevInicio}
                      disabled={true}
                    />
                  </div>
                  <div className="col w2">
                    <Input
                      type="date"
                      name="dataPrevFinalTarefaAt"
                      value={itemAtividade?.dataPrevFinal}
                      disabled={true}
                    />
                  </div>
                  <div className="col w1">
                    <Input
                      type="number"
                      name="percentualEvolucaoTarefaAt"
                      value={itemAtividade?.percentualEvolucao}
                      disabled={true}
                    />
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))}
      </CardAtividade>
      {/* ))} */}
    </Container>
  );
}

export default AtividadesList;
